// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._4MrlvXRZe6dnu {
  display: block;
}
.R1RfC8jJFTMJlv {
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  margin: var(--ds-space-0, 0);
  clear: both;
  overflow: hidden;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface-raised, #ffffff);
  text-overflow: ellipsis;
  vertical-align: top;
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
@media print {
  .R1RfC8jJFTMJlv {
    display: block;
    clear: none;
    overflow: visible;
  }
}
.R1RfC8jJFTMJlv .FCe0mb2BgcSHYk {
  min-height: 40px;
}
.R1RfC8jJFTMJlv .hPERvAPxokg05x {
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px);
}
.R1RfC8jJFTMJlv .tBAzuaictH6Wlc {
  min-height: 1.5rem;
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
}
.R1RfC8jJFTMJlv p {
  text-overflow: ellipsis;
  word-wrap: break-word;
}
.R1RfC8jJFTMJlv img {
  max-width: 100%;
  cursor: pointer;
}
.R1RfC8jJFTMJlv pre {
  max-height: 516px;
}
.R1RfC8jJFTMJlv img:last-child,
.R1RfC8jJFTMJlv p:last-child,
.R1RfC8jJFTMJlv pre:last-child {
  margin-bottom: var(--ds-space-0, 0);
}
.R1RfC8jJFTMJlv a {
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.R1RfC8jJFTMJlv a a {
  color: var(--ds-link, #0c66e4);
}
.R1RfC8jJFTMJlv .Ijf59q3IL0JsER a {
  color: var(--ds-link, #0c66e4);
}
.R1RfC8jJFTMJlv .Ijf59q3IL0JsER a:hover {
  text-decoration: underline;
}
.R1RfC8jJFTMJlv .emoji {
  width: 18px;
  height: 18px;
  vertical-align: text-bottom;
}
.R1RfC8jJFTMJlv .atMention {
  font-weight: var(--ds-font-weight-bold, bold);
}
.R1RfC8jJFTMJlv .atMention.me {
  color: var(--ds-text-brand, #0c66e4);
}
.alTov87QGWByIk {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: none;
  font-size: 12px;
  line-height: 15px;
}
.alTov87QGWByIk:hover {
  background-color: var(--ds-surface-raised, #ffffff);
}
.Xfg5GTUiZ1tTRp {
  width: 100%;
}
.hqb7HfZs84A5ln {
  display: block;
  position: absolute;
  z-index: 1;
  right: var(--ds-space-0, 0);
  bottom: 30px;
  left: var(--ds-space-0, 0);
  height: 40px;
  background: linear-gradient(to bottom, var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0)), var(--ds-surface-raised, #ffffff));
}
.alTov87QGWByIk .hqb7HfZs84A5ln {
  height: 30px;
  background: linear-gradient(to bottom, var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0)), var(--ds-surface-raised, #ffffff));
}
.pmT25uPYmXHVcN {
  position: relative;
  max-height: 200px;
}
.pmT25uPYmXHVcN.alTov87QGWByIk {
  max-height: 85px;
}
.f6x9Z6uSWiofOh {
  position: absolute;
  z-index: 1;
  bottom: var(--ds-space-0, 0);
  height: 30px;
  margin: var(--ds-space-0, 0);
  background: var(--ds-surface-raised, #ffffff);
}
.f6x9Z6uSWiofOh:hover {
  background: var(--ds-surface-raised, #ffffff);
}
.alTov87QGWByIk .f6x9Z6uSWiofOh {
  background: var(--ds-surface-raised, #ffffff);
  font-size: 12px;
}
.alTov87QGWByIk .f6x9Z6uSWiofOh:hover {
  background: var(--ds-surface-raised, #ffffff);
}
.iHft0HNLU9B7sR {
  position: relative;
  z-index: 1;
  height: 30px;
  margin: var(--ds-space-0, 0);
  background: var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0));
}
.iHft0HNLU9B7sR:hover {
  background: var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0));
}
.alTov87QGWByIk .iHft0HNLU9B7sR {
  font-size: 12px;
}
`, ""]);
// Exports
export var commentContainer = `_4MrlvXRZe6dnu`;
export var comment = `R1RfC8jJFTMJlv`;
export var collapsedComment = `FCe0mb2BgcSHYk`;
export var currentComment = `hPERvAPxokg05x`;
export var reducedRendererPadding = `tBAzuaictH6Wlc`;
export var naturalLinkStyling = `Ijf59q3IL0JsER`;
export var reactionAdded = `alTov87QGWByIk`;
export var isFullWidth = `Xfg5GTUiZ1tTRp`;
export var truncationOverlay = `hqb7HfZs84A5ln`;
export var isTruncated = `pmT25uPYmXHVcN`;
export var showMoreButton = `f6x9Z6uSWiofOh`;
export var showLessButton = `iHft0HNLU9B7sR`;
export default ___CSS_LOADER_EXPORT___;
